import { Component } from 'preact';
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import { locationPartnerServices } from "../../../services/location-services";
import ErrorBlock from "../../../components/shared/ErrorBlock";
import Loading from "../../../components/shared/Loading";
import ButtonsConstructor from "../../../components/shared/Input/Button/ButtonsConstructor";
import BoxTerminal from "../../../components/shared/BoxTerminal";
import Interpret from "../../../components/shared/Localization/Interpret";

class DeliveryWizardPartner extends Component {
	constructor(props) {
		super();

		this.state = {
			loading: true,
			error: null,
			partners: [],
			selectedPartner: props.selectedPartner,
		}
	}

	componentDidMount() {
		this._refresh();
	}

	_renderSelector() {
		const {partners, selectedPartner} = this.state;

		return <ButtonsConstructor buttons={partners?.map(partner => {
			return {
				text: partner.name,
				textTranslated: true,
				active: partner.id === selectedPartner?.id,
				action: () => this.setState({selectedPartner: partner}),
			}
		}) ?? []}/>
	}

	_renderContent() {
		const {onContinue} = this.props;
		const {partners, selectedPartner} = this.state;

		return (
			<>
				<BoxTerminal
					title={"box.deliverPackage"}
					contentSlot={
						<div className={"selector"}>
							{this._renderSelector()}
						</div>
					}
					contentHeaderSlot={
						<div className={"title"}>
							<Interpret id={"selectPartner"}/>
						</div>
					}
				/>
				<nav class={"action-buttons"}>
					<ButtonsConstructor buttons={[
						{
							className: "confirm-button",
							text: "continue",
							action: () => onContinue(selectedPartner),
							disabled: !selectedPartner,
						}
					]}/>
				</nav>
			</>
		)
	}

	render({className, style, onContinue}, {loading, error, partners, selectedPartner}) {
		return (
			<section className={combineClasses("delivery-wizard-partner", className)} style={style}>
				{loading && <Loading block={true}/>}
				{error && <ErrorBlock error={error} onRetry={() => this._refresh()}/>}

				{
					!loading &&
					!error &&
					this._renderContent()
				}
			</section>
		);
	}

	_refresh() {
		const {locationID, onContinue} = this.props;

		this.setState({
			loading: true,
			error: null,
		});
		locationPartnerServices(locationID).getList().then(partners => {
			if(partners.length < 2) {
				onContinue(partners?.[0]);
			}
			else {
				this.setState({partners});
			}
		}, error => {
			this.setState({error});
		}).finally(() => {
			this.setState({loading: false});
		});
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			locationID: PropTypes.number.isRequired,
			selectedPartner: PropTypes.object,

			onContinue: PropTypes.func.isRequired,
		}
	}

	static get stateTypes() {
		return {
			loading: PropTypes.bool,
			error: PropTypes.object,
			partners: PropTypes.array,
		}
	}
}

export default DeliveryWizardPartner;
